<template>
  <div class="position-relative">
    <b-container fluid class="ps-0">
      <b-row>
        <b-col lg="3" xl="2" xxl="2" md="3" sm="2" class="staticleftsidebar">
          <LeftBar pagename="ManufacturerMasterDetails" masterheading="Manufacture Master" v-model="datas"
            :storestatus="true" :listed="sidebardata">
          </LeftBar>
          <a class="back-btn" @click="$router.push({ path: '/ManufacturerMasterTableview' })">
            <img alt="Vue logo" class="back" src="../../../../../../assets/Img/icons/backtoright.svg" width="125"
              height="125" />
          </a>
        </b-col>
        <b-col lg="9" xl="10" xxl="10" md="9" sm="10">
          <b-container>
            <b-row>
              <b-col class="my-5">
                <p class="light-txt">{{ datas.Code }}</p>
                <Headerlayout :headertext="datas.Name"></Headerlayout>
              </b-col>
            </b-row>
            <!-- {{ Id }} -->
            <b-row>
              <b-col>
                <TabView class="tabview-custom" :scrollable="true">
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-align-left pe-3"></i>
                      <span>Details</span>
                    </template>
                    <div>
                      <ManufacturerDetailsVue />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-shopping-bag pe-3"></i>
                      <span>Items</span>
                    </template>
                    <div>
                      <ManufacturerItemMappingTable :propsParams="datas.Id" />
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <template #header>
                      <i class="pi pi-save pe-3"></i>
                      <span>Suppliers</span>
                    </template>
                    <div>
                      <ManufacturerSupplierMappingTable />
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <template #header>
                      <i class="pi pi-users pe-3"></i>
                      <span>Documents</span>
                    </template>
                    <div>
                      <ItemDetailsDocumentsTableView />
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <template #header>
                      <i class="pi pi-users pe-3"></i>
                      <span>Logs</span>
                    </template>
                    <div>
                      <Log />
                    </div>
                  </TabPanel>
                </TabView>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <div class="center" v-if="loading">
      <Loader :loading="loading" />
    </div>
  </div>
</template>

<script lang="ts">
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import LeftBar from "../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";

// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import Log from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute } from "vue-router";
import POTableview from "../../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import IssueTable from "../../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/ItemIssueTable.vue";
import GrnTable from "../../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import PurchaseIndentTableVue from "../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import QuotesTableview from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTableview.vue";
import storetab from "../../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreTab/mainstore.vue";
import ItemStoreMappingCreation from "../../../Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import service from "../../../../Service/ManufacturerService";
import ManufacturerMasterTableview from "./ManufacturerMasterTableview.vue";
import ManufacturerDetailsVue from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerDetails.vue";
import ItemDetailsDocumentsTableView from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ItemDetailsDocumentsTableView.vue";
import ManufacturerItemMappingTable from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerItemMappingTable.vue";
import ManufacturerSupplierMappingTable from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerSupplierMappingTable.vue";
export default defineComponent({
  components: {
    ItemStoreMappingCreation,
    QuotesTableview,
    POTableview,
    LeftBar,
    Details,
    MemberDetails,
    // Rightsidebar,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    PITable,
    IssueTable,
    GrnTable,
    storetab,
    ManufacturerMasterTableview,
    ManufacturerSupplierMappingTable,
    ManufacturerDetailsVue,
    ItemDetailsDocumentsTableView,
    ManufacturerItemMappingTable,
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
  },
  setup() {
    onMounted(() => {
      IsShow();
    });
    const loading = ref(false)

    let sidebardata = ref([]);
    let datas = ref({
      Id: ref(),
      Name: '',
      Code: ''
    });
    const route = useRoute();

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    // const sidebardata = [
    //     {
    //         id: "SUP9856",
    //         // store: "MS",
    //         storename: "Maheshwari PVT Limited",
    //     },
    //     // {
    //     //     id: "SUP9856",
    //     //     store: "SS",
    //     //     storename: "MainStore Supplies",
    //     // },
    // ];
    const paramValues = ref({
      Id: "",
      Type: "",
    });

    // const route = useRoute();

    let session: any = localStorage.getItem('UsersData')

    session = JSON.parse(session)
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    watch(
      () => route.query.Id,
      (newVal: any) => {
        debugger;
        // alert('newVal')
        paramValues.value.Id = newVal;
        paramValues.value.Type = route.query.Type as string;
      }
    );
    //Table List
    async function IsShow() {
      debugger;
      loading.value = true

      try {
        const data_response = await service.getdata();

        sidebardata.value = data_response["result"].filter((items) => items.HospitalId == HospitalId && items.BranchId == BranchId);
        let obj = sidebardata.value.filter((items) => items['Id'] == route.query.id)

        datas.value.Name = obj[0]['Name']
        datas.value.Code = obj[0]['Code']
        datas.value.Id = obj[0]['Id']
        console.log(sidebardata.value);
        loading.value = false

      } catch (error) {
        loading.value = false

        alert(error);
      }
    }

    return {
      sidebardata,
      paramValue,
      IsShow,
      datas,
      loading,
    };
  },
});
</script>

<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.staticleftsidebar {
  position: sticky !important;
  top: 0;
}
</style>
